import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LEARN_ROUTES } from '../config/learnRoutes';

// The root (learn.novara.tech) funnels straight into the product so no one lands on a
// marketing page:
//   - signed-in users go to the /learn dashboard;
//   - everyone else goes to THE FIRST CHALLENGE, and is invited to register after it.
//
// CHANGED 2026-09-17 (Mr. Chen, item 4). This used to send an anonymous visitor to
// `/register?next=/learn`, and the comment here described the intent as "account first,
// then the first experience as the dashboard's one to-do". That is the order his decision
// reverses: "Experience the first opening challenge → explain the next five days and invite
// registration after that challenge … Do not place registration and all questionnaires
// before the first experience."
//
// A returning visitor with no session still reaches /login and /register directly, and the
// first challenge itself offers the sign-in route for someone who already has an account —
// so this is not a way of hiding the door, only of putting the experience in front of it.
//
// The Keyhole pilot entry (/enter) is parked, not deleted (22 Aug): still routable by
// invite link, no longer the default funnel.
export default function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex-center" style={{ minHeight: '100vh' }}>
        <div className="spinner spinner-lg" />
      </div>
    );
  }
  return (
    <Navigate
      to={isAuthenticated ? LEARN_ROUTES.dashboard : LEARN_ROUTES.flare}
      replace
    />
  );
}
